import React from "react";
import { useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { setGeneralFilter } from "../../../../../../store/manager/actions";
import { useSelector } from "react-redux";

const ManagerFilterButton = ({ t, filter }) => {
  const dispatch = useDispatch();

  const mainTheme = useSelector((state) => state.Layout.mainTheme);
  const { loadingActivity, loadingSkills, loadingAgent } = useSelector(
    (state) => state.Manager
  );

  const handleFilter = (value) => {
    dispatch(setGeneralFilter(value));
  };

  return (
    <Button
      className={`text-nowrap header-button-filter ${mainTheme}`}
      onClick={() => handleFilter(filter)}
      disabled={loadingActivity || loadingSkills || loadingAgent}
    >
      <i className="bx bx-filter-alt mr-2 align-self-center" />
      {t("Filter")}
    </Button>
  );
};

export default withTranslation()(ManagerFilterButton);
